<div class="header-c">
    Ticket Promedio por transacción
    <epy-tooltip placement="top" style="width: 18px;display: inline-block;">
        <span class="difference" slot="trigger">
            <i class="fa fa-info-circle info" aria-hidden="true"></i>
        </span>
        Ticket Promedio por transacción en litros y $ por estación.
    </epy-tooltip>
    &nbsp;
    <input type="checkbox" id="checkbox-tickets" [(ngModel)]="showScale" (ngModelChange)="setData()"
        *ngIf="productType !== 'total'">
    <label style="font-size: 13px;margin-bottom: 0;margin-left: .2%;" for="checkbox-tickets"
        *ngIf="productType !== 'total'">
        Escala desde 0
    </label>
</div>
<div *ngIf="reqst===1" class="text-center loader-container">
    <div class="spinner-grow align-middle text-primary" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>

<div [ngClass]="{'flex-item': (period === 'month' || (period === 'day' && (days === 15 || days === 30))) && !station,'flex-right': period === 'week' || (period === 'day' && days !== 15 && days !== 30) || station }"
    *ngIf="reqst===2">
    <div>
        <highcharts-chart id="mychart8" [Highcharts]="Highcharts" [options]="chartOptions"
            [ngStyle]="{ 'height': station || period !== 'month' && !(period === 'week' && (weeks === 8 || weeks === 12)) && !(period === 'day' && (days === 15 || days === 30)) ? 'auto': '310px'}"
            style="width: 100%;display: block;overflow: hidden;"></highcharts-chart>

    </div>
</div>